module.exports = __webpack_public_path__ + "static/media/support.6d82afa7.svg";